import React from "react";
import { Container, Row } from "reactstrap";
import NavBar from "../NavBar";
import "./ContestSkeleton.css";

const ContestSkeleton = () => {
  return (
    <div className="contest-skeleton-page">
      <Container fluid className="px-0">
        <Row className="g-0">
          <NavBar />
        </Row>

        <div className="contest-skeleton-container">
          {/* Back button skeleton */}
          <div className="contest-shimmer-box contest-skel-back-btn" />

          {/* Hero Card Skeleton */}
          <div className="contest-skel-hero-card">
            <div className="contest-skel-hero-grid">
              {/* Left Column */}
              <div className="contest-skel-hero-left">
                {/* Badge */}
                <div className="contest-shimmer-box contest-skel-badge" />

                {/* Title */}
                <div className="contest-shimmer-box contest-skel-title" />

                {/* Meta tags */}
                <div className="contest-skel-meta-row">
                  <div className="contest-shimmer-box contest-skel-meta-pill" />
                  <div className="contest-shimmer-box contest-skel-meta-pill" />
                  <div className="contest-shimmer-box contest-skel-meta-pill" />
                </div>

                {/* Description lines */}
                <div className="contest-shimmer-box contest-skel-desc-1" />
                <div className="contest-shimmer-box contest-skel-desc-2" />

                {/* CTA Button */}
                <div className="contest-shimmer-box contest-skel-cta" />

                {/* 3 Quick Stat Cards */}
                <div className="contest-skel-stats-row">
                  <div className="contest-shimmer-box contest-skel-stat-card" />
                  <div className="contest-shimmer-box contest-skel-stat-card" />
                  <div className="contest-shimmer-box contest-skel-stat-card" />
                </div>
              </div>

              {/* Right Column (Artwork Banner) */}
              <div className="contest-skel-hero-right">
                <div className="contest-shimmer-box contest-skel-artwork" />
              </div>
            </div>
          </div>

          {/* Editorial Card Skeleton */}
          <div className="contest-skel-editorial-card">
            <div className="contest-shimmer-box contest-skel-num" />
            <div className="contest-skel-editorial-content">
              <div className="contest-shimmer-box contest-skel-editorial-title" />
              <div className="contest-shimmer-box contest-skel-editorial-line" />
              <div className="contest-shimmer-box contest-skel-editorial-line-short" />
            </div>
            <div className="contest-shimmer-box contest-skel-editorial-icon" />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ContestSkeleton;
